import React, { useState, type JSX } from "react";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { CardContainer, OuterCardContainer } from "../../components/Card/CardContainer";
import { Tabs } from "antd";
import Text from "../../components/Text/Text";
import { useEffectOnce } from "react-use";
import { MainOrderCreditDetailTab } from "./DetailTabs/Main";
import { InvoicesOrderCreditDetailTab } from "./DetailTabs/Invoices";
import { OverCreditOrderCreditDetailTab } from "./DetailTabs/OverCredit";
import { countTabs, getInvoiceCountByCusCom } from "../../datasource/OrderCreditDatasource";
import { useRecoilState } from "recoil";
import { creditLimitDetailState } from "../../store/CreditLimitDetail";
import { CreditUsingHistory } from "./DetailTabs/CreditUsingHistory";
import { MainOrderCreditDetailTabNew } from "./DetailTabs/MainNew";

const datePattern = "DD/MM/YYYY, HH:mm น.";

export const OrderCreditDetail: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;
  const navigate = useNavigate();

  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[3];

  const [tabKey, setTabKey] = useState<any>("DETAIL");

  const [state, setState] = useRecoilState(creditLimitDetailState);

  const [loadingTabsCount, setTabCount] = useState(false);
  const [tabsCount, setCountTabs] = useState({ countTemporaryCreditLimit: 0, countInvoice: 0 });

  useEffectOnce(() => {
    fetchData();
  });

  const fetchData = async () => {
    setTabCount(true);
    const data = await countTabs(id);
    const data2 = await getInvoiceCountByCusCom(id);
    setState({
      ...state,
      countInvoiceStatus: {
        ALREADY_PAID: data2.paid,
        WAITING_PAID: data2.waiting,
      },
    });
    setCountTabs({ ...data, countInvoice: data2.waiting });
    setTabCount(false);
  };

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={"รายละเอียดวงเงินร้านค้า"}
        showBack
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "วงเงินร้านค้า", path: "/order/shop-credit-limit" },
              {
                text: "รายละเอียดวงเงินร้านค้า",
                path: window.location.pathname,
              },
            ]}
          />
        }
        // extra={
        //   <Button
        //     title='อัปเดตข้อมูลใหม่'
        //     typeButton='border-primary'
        //     icon={<img src={icon.reload} style={{ width: 15, height: 17, marginBottom: 4 }} />}
        //     onClick={() => fetchData()}
        //     loading={state.loading}
        //   />
        // }
      />
    );
  };

  const tabsData: { key: string; label: React.ReactNode; children?: JSX.Element | undefined }[] = [
    {
      key: "DETAIL",
      label: "รายละเอียด",
      children: <MainOrderCreditDetailTabNew sync />,
    },
    {
      key: "INVOICE",
      label: `ใบแจ้งหนี้และเอกสารอื่นๆ (${tabsCount.countInvoice})`,
      children: <InvoicesOrderCreditDetailTab />,
    },
    {
      key: "OVER",
      label: `วงเงินเกิน`,
      children: <OverCreditOrderCreditDetailTab />,
    },
    {
      key: "HISTORY",
      label: `ประวัติการใช้งานวงเงิน`,
      children: <CreditUsingHistory />,
    },
  ].map((item) => {
    const isSelected = tabKey === item.key;
    return {
      ...item,
      label: (
        <Text
          fontSize={14}
          fontWeight={isSelected ? 600 : 400}
          color={isSelected ? "primary" : undefined}
        >
          {item.label}
        </Text>
      ),
      children: <div style={{ padding: "16px 0" }}>{item.children}</div>,
    };
  });

  return (
    <OuterCardContainer>
      <CardContainer cutBottom>
        <PageTitle />
        <br />
        <br />
        <Tabs items={tabsData} onChange={(k) => setTabKey(k)} />
      </CardContainer>
    </OuterCardContainer>
  );
};
